module.exports = __webpack_public_path__ + "static/media/CARTOONAROONY.67ebaa02.JPG";